import { g as Je } from "./_commonjsHelpers-es.js";
var Y = { exports: {} }, qe = function(e, n) {
  return function() {
    for (var t = new Array(arguments.length), s = 0; s < t.length; s++)
      t[s] = arguments[s];
    return e.apply(n, t);
  };
}, ze = qe, w = Object.prototype.toString;
function Z(r) {
  return w.call(r) === "[object Array]";
}
function W(r) {
  return typeof r > "u";
}
function Ve(r) {
  return r !== null && !W(r) && r.constructor !== null && !W(r.constructor) && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
function Ke(r) {
  return w.call(r) === "[object ArrayBuffer]";
}
function Xe(r) {
  return typeof FormData < "u" && r instanceof FormData;
}
function We(r) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(r) : e = r && r.buffer && r.buffer instanceof ArrayBuffer, e;
}
function Ge(r) {
  return typeof r == "string";
}
function Ye(r) {
  return typeof r == "number";
}
function je(r) {
  return r !== null && typeof r == "object";
}
function q(r) {
  if (w.call(r) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(r);
  return e === null || e === Object.prototype;
}
function Ze(r) {
  return w.call(r) === "[object Date]";
}
function Qe(r) {
  return w.call(r) === "[object File]";
}
function er(r) {
  return w.call(r) === "[object Blob]";
}
function Ne(r) {
  return w.call(r) === "[object Function]";
}
function rr(r) {
  return je(r) && Ne(r.pipe);
}
function tr(r) {
  return typeof URLSearchParams < "u" && r instanceof URLSearchParams;
}
function nr(r) {
  return r.trim ? r.trim() : r.replace(/^\s+|\s+$/g, "");
}
function ar() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Q(r, e) {
  if (!(r === null || typeof r > "u"))
    if (typeof r != "object" && (r = [r]), Z(r))
      for (var n = 0, a = r.length; n < a; n++)
        e.call(null, r[n], n, r);
    else
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && e.call(null, r[t], t, r);
}
function G() {
  var r = {};
  function e(t, s) {
    q(r[s]) && q(t) ? r[s] = G(r[s], t) : q(t) ? r[s] = G({}, t) : Z(t) ? r[s] = t.slice() : r[s] = t;
  }
  for (var n = 0, a = arguments.length; n < a; n++)
    Q(arguments[n], e);
  return r;
}
function sr(r, e, n) {
  return Q(e, function(t, s) {
    n && typeof t == "function" ? r[s] = ze(t, n) : r[s] = t;
  }), r;
}
function ir(r) {
  return r.charCodeAt(0) === 65279 && (r = r.slice(1)), r;
}
var v = {
  isArray: Z,
  isArrayBuffer: Ke,
  isBuffer: Ve,
  isFormData: Xe,
  isArrayBufferView: We,
  isString: Ge,
  isNumber: Ye,
  isObject: je,
  isPlainObject: q,
  isUndefined: W,
  isDate: Ze,
  isFile: Qe,
  isBlob: er,
  isFunction: Ne,
  isStream: rr,
  isURLSearchParams: tr,
  isStandardBrowserEnv: ar,
  forEach: Q,
  merge: G,
  extend: sr,
  trim: nr,
  stripBOM: ir
}, g = v;
function se(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Pe = function(e, n, a) {
  if (!n)
    return e;
  var t;
  if (a)
    t = a(n);
  else if (g.isURLSearchParams(n))
    t = n.toString();
  else {
    var s = [];
    g.forEach(n, function(l, i) {
      l === null || typeof l > "u" || (g.isArray(l) ? i = i + "[]" : l = [l], g.forEach(l, function(h) {
        g.isDate(h) ? h = h.toISOString() : g.isObject(h) && (h = JSON.stringify(h)), s.push(se(i) + "=" + se(h));
      }));
    }), t = s.join("&");
  }
  if (t) {
    var o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + t;
  }
  return e;
}, or = v;
function N() {
  this.handlers = [];
}
N.prototype.use = function(e, n, a) {
  return this.handlers.push({
    fulfilled: e,
    rejected: n,
    synchronous: a ? a.synchronous : !1,
    runWhen: a ? a.runWhen : null
  }), this.handlers.length - 1;
};
N.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
N.prototype.forEach = function(e) {
  or.forEach(this.handlers, function(a) {
    a !== null && e(a);
  });
};
var ur = N, fr = v, cr = function(e, n) {
  fr.forEach(e, function(t, s) {
    s !== n && s.toUpperCase() === n.toUpperCase() && (e[n] = t, delete e[s]);
  });
}, Te = function(e, n, a, t, s) {
  return e.config = n, a && (e.code = a), e.request = t, e.response = s, e.isAxiosError = !0, e.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, e;
}, U, ie;
function Ue() {
  if (ie) return U;
  ie = 1;
  var r = Te;
  return U = function(n, a, t, s, o) {
    var u = new Error(n);
    return r(u, a, t, s, o);
  }, U;
}
var k, oe;
function lr() {
  if (oe) return k;
  oe = 1;
  var r = Ue();
  return k = function(n, a, t) {
    var s = t.config.validateStatus;
    !t.status || !s || s(t.status) ? n(t) : a(r(
      "Request failed with status code " + t.status,
      t.config,
      null,
      t.request,
      t
    ));
  }, k;
}
var L, ue;
function dr() {
  if (ue) return L;
  ue = 1;
  var r = v;
  return L = r.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(a, t, s, o, u, l) {
          var i = [];
          i.push(a + "=" + encodeURIComponent(t)), r.isNumber(s) && i.push("expires=" + new Date(s).toGMTString()), r.isString(o) && i.push("path=" + o), r.isString(u) && i.push("domain=" + u), l === !0 && i.push("secure"), document.cookie = i.join("; ");
        },
        read: function(a) {
          var t = document.cookie.match(new RegExp("(^|;\\s*)(" + a + ")=([^;]*)"));
          return t ? decodeURIComponent(t[3]) : null;
        },
        remove: function(a) {
          this.write(a, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), L;
}
var B, fe;
function hr() {
  return fe || (fe = 1, B = function(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }), B;
}
var D, ce;
function pr() {
  return ce || (ce = 1, D = function(e, n) {
    return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
  }), D;
}
var $, le;
function mr() {
  if (le) return $;
  le = 1;
  var r = hr(), e = pr();
  return $ = function(a, t) {
    return a && !r(t) ? e(a, t) : t;
  }, $;
}
var I, de;
function vr() {
  if (de) return I;
  de = 1;
  var r = v, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return I = function(a) {
    var t = {}, s, o, u;
    return a && r.forEach(a.split(`
`), function(i) {
      if (u = i.indexOf(":"), s = r.trim(i.substr(0, u)).toLowerCase(), o = r.trim(i.substr(u + 1)), s) {
        if (t[s] && e.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? t[s] = (t[s] ? t[s] : []).concat([o]) : t[s] = t[s] ? t[s] + ", " + o : o;
      }
    }), t;
  }, I;
}
var F, he;
function yr() {
  if (he) return F;
  he = 1;
  var r = v;
  return F = r.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var n = /(msie|trident)/i.test(navigator.userAgent), a = document.createElement("a"), t;
      function s(o) {
        var u = o;
        return n && (a.setAttribute("href", u), u = a.href), a.setAttribute("href", u), {
          href: a.href,
          protocol: a.protocol ? a.protocol.replace(/:$/, "") : "",
          host: a.host,
          search: a.search ? a.search.replace(/^\?/, "") : "",
          hash: a.hash ? a.hash.replace(/^#/, "") : "",
          hostname: a.hostname,
          port: a.port,
          pathname: a.pathname.charAt(0) === "/" ? a.pathname : "/" + a.pathname
        };
      }
      return t = s(window.location.href), function(u) {
        var l = r.isString(u) ? s(u) : u;
        return l.protocol === t.protocol && l.host === t.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), F;
}
var H, pe;
function me() {
  if (pe) return H;
  pe = 1;
  var r = v, e = lr(), n = dr(), a = Pe, t = mr(), s = vr(), o = yr(), u = Ue();
  return H = function(i) {
    return new Promise(function(h, d) {
      var c = i.data, C = i.headers, S = i.responseType;
      r.isFormData(c) && delete C["Content-Type"];
      var f = new XMLHttpRequest();
      if (i.auth) {
        var Me = i.auth.username || "", _e = i.auth.password ? unescape(encodeURIComponent(i.auth.password)) : "";
        C.Authorization = "Basic " + btoa(Me + ":" + _e);
      }
      var te = t(i.baseURL, i.url);
      f.open(i.method.toUpperCase(), a(te, i.params, i.paramsSerializer), !0), f.timeout = i.timeout;
      function ne() {
        if (f) {
          var E = "getAllResponseHeaders" in f ? s(f.getAllResponseHeaders()) : null, b = !S || S === "text" || S === "json" ? f.responseText : f.response, O = {
            data: b,
            status: f.status,
            statusText: f.statusText,
            headers: E,
            config: i,
            request: f
          };
          e(h, d, O), f = null;
        }
      }
      if ("onloadend" in f ? f.onloadend = ne : f.onreadystatechange = function() {
        !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(ne);
      }, f.onabort = function() {
        f && (d(u("Request aborted", i, "ECONNABORTED", f)), f = null);
      }, f.onerror = function() {
        d(u("Network Error", i, null, f)), f = null;
      }, f.ontimeout = function() {
        var b = "timeout of " + i.timeout + "ms exceeded";
        i.timeoutErrorMessage && (b = i.timeoutErrorMessage), d(u(
          b,
          i,
          i.transitional && i.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          f
        )), f = null;
      }, r.isStandardBrowserEnv()) {
        var ae = (i.withCredentials || o(te)) && i.xsrfCookieName ? n.read(i.xsrfCookieName) : void 0;
        ae && (C[i.xsrfHeaderName] = ae);
      }
      "setRequestHeader" in f && r.forEach(C, function(b, O) {
        typeof c > "u" && O.toLowerCase() === "content-type" ? delete C[O] : f.setRequestHeader(O, b);
      }), r.isUndefined(i.withCredentials) || (f.withCredentials = !!i.withCredentials), S && S !== "json" && (f.responseType = i.responseType), typeof i.onDownloadProgress == "function" && f.addEventListener("progress", i.onDownloadProgress), typeof i.onUploadProgress == "function" && f.upload && f.upload.addEventListener("progress", i.onUploadProgress), i.cancelToken && i.cancelToken.promise.then(function(b) {
        f && (f.abort(), d(b), f = null);
      }), c || (c = null), f.send(c);
    });
  }, H;
}
var p = v, ve = cr, br = Te, Er = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function ye(r, e) {
  !p.isUndefined(r) && p.isUndefined(r["Content-Type"]) && (r["Content-Type"] = e);
}
function wr() {
  var r;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (r = me()), r;
}
function gr(r, e, n) {
  if (p.isString(r))
    try {
      return (e || JSON.parse)(r), p.trim(r);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (0, JSON.stringify)(r);
}
var P = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: wr(),
  transformRequest: [function(e, n) {
    return ve(n, "Accept"), ve(n, "Content-Type"), p.isFormData(e) || p.isArrayBuffer(e) || p.isBuffer(e) || p.isStream(e) || p.isFile(e) || p.isBlob(e) ? e : p.isArrayBufferView(e) ? e.buffer : p.isURLSearchParams(e) ? (ye(n, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : p.isObject(e) || n && n["Content-Type"] === "application/json" ? (ye(n, "application/json"), gr(e)) : e;
  }],
  transformResponse: [function(e) {
    var n = this.transitional, a = n && n.silentJSONParsing, t = n && n.forcedJSONParsing, s = !a && this.responseType === "json";
    if (s || t && p.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (o) {
        if (s)
          throw o.name === "SyntaxError" ? br(o, this, "E_JSON_PARSE") : o;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  }
};
P.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
p.forEach(["delete", "get", "head"], function(e) {
  P.headers[e] = {};
});
p.forEach(["post", "put", "patch"], function(e) {
  P.headers[e] = p.merge(Er);
});
var ee = P, xr = v, Rr = ee, Cr = function(e, n, a) {
  var t = this || Rr;
  return xr.forEach(a, function(o) {
    e = o.call(t, e, n);
  }), e;
}, M, be;
function ke() {
  return be || (be = 1, M = function(e) {
    return !!(e && e.__CANCEL__);
  }), M;
}
var Ee = v, _ = Cr, Sr = ke(), Or = ee;
function J(r) {
  r.cancelToken && r.cancelToken.throwIfRequested();
}
var Ar = function(e) {
  J(e), e.headers = e.headers || {}, e.data = _.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = Ee.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), Ee.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(t) {
      delete e.headers[t];
    }
  );
  var n = e.adapter || Or.adapter;
  return n(e).then(function(t) {
    return J(e), t.data = _.call(
      e,
      t.data,
      t.headers,
      e.transformResponse
    ), t;
  }, function(t) {
    return Sr(t) || (J(e), t && t.response && (t.response.data = _.call(
      e,
      t.response.data,
      t.response.headers,
      e.transformResponse
    ))), Promise.reject(t);
  });
}, m = v, Le = function(e, n) {
  n = n || {};
  var a = {}, t = ["url", "method", "data"], s = ["headers", "auth", "proxy", "params"], o = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], u = ["validateStatus"];
  function l(d, c) {
    return m.isPlainObject(d) && m.isPlainObject(c) ? m.merge(d, c) : m.isPlainObject(c) ? m.merge({}, c) : m.isArray(c) ? c.slice() : c;
  }
  function i(d) {
    m.isUndefined(n[d]) ? m.isUndefined(e[d]) || (a[d] = l(void 0, e[d])) : a[d] = l(e[d], n[d]);
  }
  m.forEach(t, function(c) {
    m.isUndefined(n[c]) || (a[c] = l(void 0, n[c]));
  }), m.forEach(s, i), m.forEach(o, function(c) {
    m.isUndefined(n[c]) ? m.isUndefined(e[c]) || (a[c] = l(void 0, e[c])) : a[c] = l(void 0, n[c]);
  }), m.forEach(u, function(c) {
    c in n ? a[c] = l(e[c], n[c]) : c in e && (a[c] = l(void 0, e[c]));
  });
  var R = t.concat(s).concat(o).concat(u), h = Object.keys(e).concat(Object.keys(n)).filter(function(c) {
    return R.indexOf(c) === -1;
  });
  return m.forEach(h, i), a;
};
const qr = "axios", jr = "0.21.4", Nr = "Promise based HTTP client for the browser and node.js", Pr = "index.js", Tr = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, Ur = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, kr = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], Lr = "Matt Zabriskie", Br = "MIT", Dr = {
  url: "https://github.com/axios/axios/issues"
}, $r = "https://axios-http.com", Ir = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, Fr = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, Hr = "dist/axios.min.js", Mr = "dist/axios.min.js", _r = "./index.d.ts", Jr = {
  "follow-redirects": "^1.14.0"
}, zr = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], Vr = {
  name: qr,
  version: jr,
  description: Nr,
  main: Pr,
  scripts: Tr,
  repository: Ur,
  keywords: kr,
  author: Lr,
  license: Br,
  bugs: Dr,
  homepage: $r,
  devDependencies: Ir,
  browser: Fr,
  jsdelivr: Hr,
  unpkg: Mr,
  typings: _r,
  dependencies: Jr,
  bundlesize: zr
};
var Be = Vr, re = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(r, e) {
  re[r] = function(a) {
    return typeof a === r || "a" + (e < 1 ? "n " : " ") + r;
  };
});
var we = {}, Kr = Be.version.split(".");
function De(r, e) {
  for (var n = e ? e.split(".") : Kr, a = r.split("."), t = 0; t < 3; t++) {
    if (n[t] > a[t])
      return !0;
    if (n[t] < a[t])
      return !1;
  }
  return !1;
}
re.transitional = function(e, n, a) {
  var t = n && De(n);
  function s(o, u) {
    return "[Axios v" + Be.version + "] Transitional option '" + o + "'" + u + (a ? ". " + a : "");
  }
  return function(o, u, l) {
    if (e === !1)
      throw new Error(s(u, " has been removed in " + n));
    return t && !we[u] && (we[u] = !0, console.warn(
      s(
        u,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(o, u, l) : !0;
  };
};
function Xr(r, e, n) {
  if (typeof r != "object")
    throw new TypeError("options must be an object");
  for (var a = Object.keys(r), t = a.length; t-- > 0; ) {
    var s = a[t], o = e[s];
    if (o) {
      var u = r[s], l = u === void 0 || o(u, s, r);
      if (l !== !0)
        throw new TypeError("option " + s + " must be " + l);
      continue;
    }
    if (n !== !0)
      throw Error("Unknown option " + s);
  }
}
var Wr = {
  isOlderVersion: De,
  assertOptions: Xr,
  validators: re
}, $e = v, Gr = Pe, ge = ur, xe = Ar, T = Le, Ie = Wr, x = Ie.validators;
function A(r) {
  this.defaults = r, this.interceptors = {
    request: new ge(),
    response: new ge()
  };
}
A.prototype.request = function(e) {
  typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = T(this.defaults, e), e.method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
  var n = e.transitional;
  n !== void 0 && Ie.assertOptions(n, {
    silentJSONParsing: x.transitional(x.boolean, "1.0.0"),
    forcedJSONParsing: x.transitional(x.boolean, "1.0.0"),
    clarifyTimeoutError: x.transitional(x.boolean, "1.0.0")
  }, !1);
  var a = [], t = !0;
  this.interceptors.request.forEach(function(d) {
    typeof d.runWhen == "function" && d.runWhen(e) === !1 || (t = t && d.synchronous, a.unshift(d.fulfilled, d.rejected));
  });
  var s = [];
  this.interceptors.response.forEach(function(d) {
    s.push(d.fulfilled, d.rejected);
  });
  var o;
  if (!t) {
    var u = [xe, void 0];
    for (Array.prototype.unshift.apply(u, a), u = u.concat(s), o = Promise.resolve(e); u.length; )
      o = o.then(u.shift(), u.shift());
    return o;
  }
  for (var l = e; a.length; ) {
    var i = a.shift(), R = a.shift();
    try {
      l = i(l);
    } catch (h) {
      R(h);
      break;
    }
  }
  try {
    o = xe(l);
  } catch (h) {
    return Promise.reject(h);
  }
  for (; s.length; )
    o = o.then(s.shift(), s.shift());
  return o;
};
A.prototype.getUri = function(e) {
  return e = T(this.defaults, e), Gr(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
};
$e.forEach(["delete", "get", "head", "options"], function(e) {
  A.prototype[e] = function(n, a) {
    return this.request(T(a || {}, {
      method: e,
      url: n,
      data: (a || {}).data
    }));
  };
});
$e.forEach(["post", "put", "patch"], function(e) {
  A.prototype[e] = function(n, a, t) {
    return this.request(T(t || {}, {
      method: e,
      url: n,
      data: a
    }));
  };
});
var Yr = A, z, Re;
function Fe() {
  if (Re) return z;
  Re = 1;
  function r(e) {
    this.message = e;
  }
  return r.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, r.prototype.__CANCEL__ = !0, z = r, z;
}
var V, Ce;
function Zr() {
  if (Ce) return V;
  Ce = 1;
  var r = Fe();
  function e(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    var a;
    this.promise = new Promise(function(o) {
      a = o;
    });
    var t = this;
    n(function(o) {
      t.reason || (t.reason = new r(o), a(t.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.source = function() {
    var a, t = new e(function(o) {
      a = o;
    });
    return {
      token: t,
      cancel: a
    };
  }, V = e, V;
}
var K, Se;
function Qr() {
  return Se || (Se = 1, K = function(e) {
    return function(a) {
      return e.apply(null, a);
    };
  }), K;
}
var X, Oe;
function et() {
  return Oe || (Oe = 1, X = function(e) {
    return typeof e == "object" && e.isAxiosError === !0;
  }), X;
}
var Ae = v, rt = qe, j = Yr, tt = Le, nt = ee;
function He(r) {
  var e = new j(r), n = rt(j.prototype.request, e);
  return Ae.extend(n, j.prototype, e), Ae.extend(n, e), n;
}
var y = He(nt);
y.Axios = j;
y.create = function(e) {
  return He(tt(y.defaults, e));
};
y.Cancel = Fe();
y.CancelToken = Zr();
y.isCancel = ke();
y.all = function(e) {
  return Promise.all(e);
};
y.spread = Qr();
y.isAxiosError = et();
Y.exports = y;
Y.exports.default = y;
var at = Y.exports, st = at;
const ot = /* @__PURE__ */ Je(st);
export {
  ot as a
};
